export default __webpack_public_path__ + "static/media/provesional_restoration_lower_11_2@2x.c49a7125.png";